import React, { Component } from "react";
import {
  Confirm,
  Divider,
  Form,
  Grid,
  Icon,
  Message,
  Segment,
  Modal,
  Header,
  Button
} from "semantic-ui-react";
import DropzoneCommon from "../../components/content/DropzoneCommon";
import ScanQrCodeComponent from "../../components/content/ScanQrCodeComponent";
import request from "../../utils/request";

class TabletImportTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eventId: this.props.match.params.id,
      sellerId: 0,
      ticketCount: 0,
      errorShow: false,
      errorMessage: "",
      successShow: false,
      successMessage: "",
      confirmOpen: false,
      sellers: [],
      orders: [],
      refunds: [],
      eventTitle: "",
      open: false
    };
  }
  openModal = () => {
    this.setState({ open: true });
  }
  closeModal = () => {
    this.setState({ open: false });
  }
  componentDidMount = () => {
    this.fetchEvent();
    this.fetchSellers();
  };
  fetchEvent = () => {
    return request
      .get(this, `api:/event/${this.state.eventId}`, {})
      .then(resp => {
        this.setState({ eventTitle: resp.title });
      });
  }
  fetchSellers = () => {
    return request
      .get(this, `api:/event-sellers/${this.state.eventId}`, {})
      .then(resp => {
        let sellers = [];
        resp.data.map((value, index) => {
          if (+value.volunteer_id === 50000) return false;
          return sellers.push({
            key: index,
            text: value.volunteer,
            value: value.volunteer_id
          });
        });
        this.setState({
          sellers: sellers
        });
      });
  };
  handleConfirm = () => {
    let self = this;
    let payload = {
      eventId: this.state.eventId,
      sellerId: this.state.sellerId,
      orders: this.state.orders,
      refunds: this.state.refunds
    };
    return request
      .post(this, "api:/event/ticket-import", payload)
      .catch(error => {
        self.setState({ formLoading: false });
        if (error.response.data.message) {
          self.setState({
            errorShow: true,
            errorMessage: error.response.data.message
          });
        } else {
          self.setState({
            errorShow: true,
            errorMessage: "Unknown Error"
          });
        }
      })
      .then(response => {
        self.setState({ formLoading: false });
        if (response.error) {
          self.setState({
            errorShow: true,
            errorMessage: response.message
          });
        } else {
          self.setState({
            result: "confirmed",
            confirmOpen: false,
            successMessage: response.message,
            successShow: true,
            sellerId: 0,
            orders: [],
            refunds: []
          });
        }
      });
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleCancel = () =>
    this.setState({
      result: "cancelled",
      confirmOpen: false
    });
  handleDrop = files => {
    let self = this;
    files.map(file => {
      self.setState({ formLoading: true });
      const formData = new FormData();
      formData.append("ticketBackups", file);
      formData.append("eventId", this.state.eventId);
      formData.append("sellerId", this.state.sellerId);
      formData.append("timestamp", (Date.now() / 1000) | 0);
      return request
        .post(this, "api:/event/ticket-import", formData)
        .catch(error => {
          self.setState({ formLoading: false });
          if (error.response.data.message) {
            self.setState({
              errorShow: true,
              errorMessage: error.response.data.message
            });
          } else {
            self.setState({
              errorShow: true,
              errorMessage: "Unknown Error"
            });
          }
        })
        .then(response => {
          self.setState({ formLoading: false });
          if (response.error) {
            self.setState({
              errorShow: true,
              errorMessage: response.message
            });
          } else if (typeof response == 'undefined' || response.exception) {
            self.setState({
              errorShow: true,
              errorMessage: "Unknown Error"
            });
          } else {
            self.setState({
              errorShow: false,
              errorMessage: "",
              confirmOpen: true,
              ticketCount: response.ticketCount,
              orders: response.orders,
              refunds: response.refunds
            });
          }
        });
    });
  };
  render() {
    const {
      confirmOpen,
      errorShow,
      errorMessage,
      eventId,
      eventTitle,
      ticketCount,
      sellers,
      sellerId,
      successMessage,
      successShow
    } = this.state;
    return (
      <Segment basic>
        <Confirm
          open={confirmOpen}
          content={
            ticketCount +
            " transactions were found. Are you sure you want to process these new tickets?"
          }
          cancelButton="Cancel"
          confirmButton="Process"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Grid columns="equal">
          <Grid.Column>
            <p>
              This page will allow you to import stored tickets from a tablet if
              the tablet loses connectivity. To import tickets, follow the steps
              below:
            </p>
            <ul>
              <li>
                Verify that the event selected above is correct. The current
                event selected is: <strong>{eventTitle}</strong>
              </li>
              <li>Select the correct seller who sold the tickets.</li>
              <li>Connect the tablet to this PC with a USB cord.</li>
              <li>
                Click the "<Icon name="upload" /> Upload Files" button on the
                right and then locate the tablet (it will likely be listed under
                "This PC").
              </li>
              <li>
                Browse through the tablet directory to find the folder
                named "BumpBackups" and open it.
              </li>
              <li>
                Select the file named{" "}
                <strong>
                  "order-backups-
                  {eventId}
                  .txt"
                </strong>{" "}
                and click "Open".
              </li>
              <li>
                Once the upload is complete, you will be prompted to "Process
                Tickets".
              </li>
            </ul>
          </Grid.Column>
          <Grid.Column>
            <Message negative hidden={!errorShow}>
              <p>{errorMessage}</p>
            </Message>
            <Message positive hidden={!successShow}>
              <p>{successMessage}</p>
            </Message>
            <Form.Select
              name="sellerId"
              fluid
              label="Choose Seller"
              placeholder="Choose Seller"
              search
              options={sellers}
              value={sellerId}
              onChange={this.handleChange}
            />
            <Divider hidden />
            <DropzoneCommon
              onDrop={this.handleDrop}
              accept="text/plain"
              className="ui segment"
            />
          </Grid.Column>
        </Grid>
        <Modal
          trigger={<Button primary onClick={this.openModal}><Icon name="qrcode" />Scan QR Code</Button>}
          closeIcon
          open={this.state.open}
          onClose={this.closeModal}
        >
          <Header icon='qrcode' content='Scan QR Code' />
          <Modal.Content><ScanQrCodeComponent /></Modal.Content>
        </Modal>
      </Segment>
    );
  }
}

export default TabletImportTab;
